import { CSSProperties } from 'react';
import Loader from 'rsuite/Loader';

export interface LazyLoadingAnimationProps {
    style?: CSSProperties;
}

export var LazyLoadingAnimation = (props: LazyLoadingAnimationProps) => (
    <div style={{
        borderRadius: 15, position: "absolute", overflow: "hidden",
        ...props.style
    }}>
        <Loader center backdrop inverse speed='normal' size='md' />
    </div>
);